import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import {withTheme} from '../HOC/withTheme';

const HeadDiv = styled.div`
  text-transform: uppercase;
  font-family: 'Segoe UI', sans-serif;
  background-color: ${({color}) => color};
  width: 100%;
  height: 50px;
  color: white;
  padding-left: 15px;
  padding-top: .9rem;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  font-size: 14px;
  margin-bottom: 10px;
`;

const ColoredHeader = ({theme, ...props}) => {
  return (
    <HeadDiv color={theme.screen.header} {...props}/>
  );
};

ColoredHeader.propTypes = {
  theme: PropTypes.shape({
    screen: PropTypes.shape({
      header: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default withTheme(ColoredHeader);
